<template>
    <div>
        <el-button type="primary" size="mini" @click="showdialog=true; getCityList()">添加案例</el-button>
        <el-dialog
            title="添加案例"
            :visible.sync="showdialog"
            width="600px"
            append-to-body>

            <div class="base-warp">
                <el-form :model="form" label-width="80px" :inline="false" size="normal">
                    <el-form-item label="完成日期">
                        <el-date-picker
                            v-model="form.date"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="客户姓名">
                        <el-input maxlength="16" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="客户手机">
                        <el-input type="number" maxlength="11" v-model="form.telephone"></el-input>
                    </el-form-item>
                    <el-form-item label="关联楼盘">
                        <div class="flex-box">
                            <el-input v-model="form.projectname" disabled></el-input>
                            <tutor-project @getProject="getProject" v-if="regions" :regions="regions"></tutor-project>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="confirm">保存</el-button>
                        <el-button @click="showdialog = false">取消</el-button>
                    </el-form-item>
                </el-form>
                
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
import tutorProject from './tutor-project.vue'
export default {
  components: { tutorProject },
    name: 'TutorAdd',
    data() {
        return {
            showdialog: false,
            form: {
                date: '',
                name: '',
                telephone: '',
                projectname: '',
                projectid: '',
            },
            regions: [],
        }
    },
    props: {
        id: {
            type: String,
            default: ''
        },
    },
    methods: {
        getProject(item) {
            this.form.projectname = item.name;
            this.form.projectid = item._id['$oid'];
        },
        getCityList() {
            this.$api.getCityList('').then(
                data=>{
                    this.regions = data;
                }
            )
        },
        confirm() {
            var params = {
                id: this.id,
                date: this.form.date,
                name: this.form.name,
                telephone: this.form.telephone,
                projectid: this.form.projectid,
            }
            this.$api.addTutorCase(params).then(
                data=>{
                    this.$message.success(data);
                    this.showdialog = false;
                }
            )
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
</style>